// extracted by mini-css-extract-plugin
module.exports = {"form-body":"HotelSearch_form-body__XaoLX","search-button":"HotelSearch_search-button__hJgfA","search-button--error":"HotelSearch_search-button--error__lq3tg"};